import { Divider, Grid, Paper, Skeleton, Stack, Typography } from "@mui/material"
import React from "react"
import { AdjustmentEquipment } from "../../Objects/AdjustmentEquipment"

export interface AdjustmentEquipmentListProps {
    adj_equipment_list?: AdjustmentEquipment[]
}
const AdjustmentEquipmentList: React.FC<AdjustmentEquipmentListProps> = ({
    adj_equipment_list
}) => {
    return (
        <Paper
            variant="outlined"
            sx={{
                p: 2
            }}
        >
            <Stack
                spacing={1}
            >
                {adj_equipment_list ? adj_equipment_list.map((adjustment, index) => (
                    <Grid container key={index}
                        sx={{
                            px: 2
                        }}
                    >
                        <Grid item xs={10} sm={5}>
                            <Typography textAlign="left">{adjustment.item}</Typography>
                        </Grid>
                        <Grid item xs={2} sm={2}>
                            <Typography textAlign="right">×{adjustment.number}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={5}>
                            <Typography textAlign="right">{adjustment.charge.toLocaleString()}円</Typography>
                        </Grid>
                    </Grid>
                )) : (
                    <Skeleton variant="rectangular" height={50} />
                )}
                {adj_equipment_list && adj_equipment_list.length > 0 &&
                    <Divider />
                }
                <Grid container
                    sx={{
                        px: 2
                    }}
                >
                    <Grid item xs={10} sm={5}>
                        <Typography textAlign="left" color="primary" fontWeight="bold">機材レンタル代合計</Typography>
                    </Grid>
                    <Grid item xs={2} sm={2}>
                        <Typography textAlign="right">×{adj_equipment_list ? adj_equipment_list.reduce<number>((prev, adjustment) => prev + adjustment.number, 0) : "-"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <Typography textAlign="right">{adj_equipment_list ? adj_equipment_list.reduce<number>((prev, adjustment) => prev + adjustment.charge, 0).toLocaleString() : "-"}円</Typography>
                    </Grid>
                </Grid>
            </Stack>
        </Paper>
    )
}

export default AdjustmentEquipmentList